<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="860"
    style="border-radius: 8px"
  >
    <v-card>
      <v-card-title class="primary px-4">
        <div class="d-flex align-center">
          <v-btn color="white" icon :disabled="saving" @click="cancelAction"
            ><v-icon size="20px">mdi-close</v-icon></v-btn
          >
          <span
            class="white--text"
            style="font-size: 16px !important; font-weight: 400"
            >Ứng dụng OTP</span
          >
        </div>
      </v-card-title>
      <v-card-text class="pt-4 black--text">
        <p class="neutral--text mb-3" style="font-size: 13px">
          Mỗi ứng dụng gửi App ID trong header <b>X-App-Id</b> và có mã OTP
          riêng. Tên ứng dụng hiện trong tin nhắn Telegram. Tắt ứng dụng thì ứng
          dụng đó không xin/nhập được mã OTP.
        </p>

        <v-row class="m-0 align-start" dense>
          <v-col cols="12" sm="4">
            <v-text-field
              v-model.trim="form.name"
              label="Tên ứng dụng *"
              outlined
              dense
              counter="100"
              maxlength="100"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="5">
            <v-text-field
              v-model.trim="form.description"
              label="Mô tả"
              outlined
              dense
              maxlength="255"
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" class="d-flex">
            <v-btn
              color="primary"
              class="rounded-lg mr-2"
              depressed
              :loading="saving"
              :disabled="!form.name"
              @click="save"
            >
              {{ editingId ? "Lưu" : "Thêm" }}
            </v-btn>
            <v-btn
              v-if="editingId"
              color="neutral_color_sub4"
              class="rounded-lg"
              depressed
              :disabled="saving"
              @click="resetForm"
            >
              Hủy sửa
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="clients"
          :loading="loading"
          hide-default-footer
          disable-pagination
          no-data-text="Chưa có ứng dụng nào"
          class="mt-3"
        >
          <template v-slot:[`item.app_id`]="{ item }">
            <code style="font-size: 12px">{{ item.app_id }}</code>
            <v-btn icon x-small title="Sao chép" @click="copy(item.app_id)">
              <v-icon size="16">mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.is_active`]="{ item }">
            <v-switch
              :input-value="item.is_active"
              :disabled="saving"
              dense
              hide-details
              class="mt-0"
              @change="toggleActive(item, $event)"
            ></v-switch>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon small title="Sửa" @click="edit(item)">
              <v-icon size="18">mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/services"

export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    cancelAction: {
      type: Function,
      default() {},
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      saving: false,
      clients: [],
      editingId: null,
      form: { name: "", description: "" },
      headers: [
        { text: "Tên", value: "name", sortable: false },
        { text: "App ID (X-App-Id)", value: "app_id", sortable: false },
        { text: "Mô tả", value: "description", sortable: false },
        { text: "Bật", value: "is_active", sortable: false, width: 70 },
        { text: "", value: "actions", sortable: false, width: 50 },
      ],
    }
  },
  watch: {
    isVisible() {
      this.dialog = this.isVisible
      if (this.isVisible) {
        this.resetForm()
        this.load()
      }
    },
  },
  methods: {
    errorMessage(res, fallback) {
      return (res && res.data && res.data.message) || fallback
    },
    async load() {
      this.loading = true
      const res = await api.twoFactor.getOtpClients()
      this.loading = false
      if (res && res.status === 200) {
        this.clients = (res.data.data && res.data.data.clients) || []
        return
      }
      this.$store.commit(
        "toast/getError",
        this.errorMessage(res, "Không tải được danh sách ứng dụng OTP"),
      )
    },
    resetForm() {
      this.editingId = null
      this.form = { name: "", description: "" }
    },
    edit(item) {
      this.editingId = item.id
      this.form = { name: item.name, description: item.description || "" }
    },
    async save() {
      if (!this.form.name || this.saving) {
        return
      }
      this.saving = true
      const payload = {
        name: this.form.name,
        description: this.form.description || null,
      }
      const res = this.editingId
        ? await api.twoFactor.updateOtpClient(this.editingId, payload)
        : await api.twoFactor.createOtpClient(payload)
      this.saving = false
      if (res && [200, 201].includes(res.status)) {
        this.$store.commit(
          "toast/getSuccess",
          this.editingId ? "Đã lưu ứng dụng OTP" : "Đã thêm ứng dụng OTP",
        )
        this.resetForm()
        this.load()
        return
      }
      this.$store.commit(
        "toast/getError",
        this.errorMessage(res, "Không lưu được ứng dụng OTP"),
      )
    },
    async toggleActive(item, value) {
      this.saving = true
      const res = await api.twoFactor.updateOtpClient(item.id, {
        is_active: !!value,
      })
      this.saving = false
      if (res && res.status === 200) {
        item.is_active = !!value
        return
      }
      this.$store.commit(
        "toast/getError",
        this.errorMessage(res, "Không cập nhật được trạng thái"),
      )
      // Trả switch về trạng thái cũ
      this.load()
    },
    async copy(text) {
      try {
        await navigator.clipboard.writeText(text)
        this.$store.commit("toast/getSuccess", "Đã sao chép App ID")
      } catch (error) {
        this.$store.commit(
          "toast/getError",
          "Không sao chép được, hãy bôi đen và copy thủ công",
        )
      }
    },
  },
}
</script>
